import type { ZInfer, contactSchemas } from 'types';
import { Api } from '..';

export class ContactNet {
  static submit = (body: ZInfer<typeof contactSchemas.contactUs>) =>
    Api.post<'contact', 'contact'>(`/contact`, { body });
}
